import { WizCommand } from '@wizeoo/akm-component-lib';
import { MatrixVO } from '@wizeoo/akm-compute-lib';
import { AkmBDD, BddMatrixData, LocalMatrix } from '@wizeoo/akm-worker-lib';
import { Model } from '../../model/model';
import { Matrix } from '@wizeoo/akm-message-lib';

/** chargement des matrices du cache (ROWS) */
export class LocalMatrixCommand extends WizCommand<BddMatrixData[]> {
  
  public matrix: MatrixVO; // la conf d'appel
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 


  /**
   * Recherche des visions du domain pour le user connecté
   */
  public getLocal(matrix: MatrixVO, callback: Function): LocalMatrixCommand {
    
    this.matrix = matrix;
    this.configure(callback, true);
    return this;
  }

  public wizExecute(): Promise<any> {
    return AkmBDD.getInstance().table(AkmBDD.BDD_MATRIX_DATA_KEY).where('matrixid')
          .equals(this.matrix.id)
          .toArray();;
  }

  wizResult() {
    const local : BddMatrixData[] = this.result;
    this.matrix.rows = local;
    // console.log('local', local);
    super.wizResult(); 
  }
}
